import { useContext, useState } from "react";
import {
  getTenantBranding,
} from "../services/console/tenantbranding";
import { AppContext } from "../context";

type UseType = "DATA" | "ACTIONS";
type ActionType = "CREATE" | "UPDATE" | "DELETE";

const handleTenantBrandingActionFunction = (action: ActionType, t: Function) => {
  switch (action) {
    case "CREATE":
      return {
        actionFn: (a:any)=>{},
        fnMsg: t("Translations.translationsApiCreateLabel"),
      };
    case "UPDATE":
      return {
        actionFn: (a:any)=>{},
        fnMsg: t("Translations.translationsApiUpdateLabel"),
      };
    case "DELETE":
      return {
        actionFn: (a:any)=>{},
        fnMsg: t("Translations.translationsApiDeleteLabel"),
      };
    default:
      return {
        actionFn: () => {},
        fnMsg: "",
      };
  }
};

export const useTenantBranding = (type: UseType) => {
  const {
    t,
    toast,
    setAppState,
  } = useContext(AppContext);
  const [data, setData] = useState<any | null>(null);
  const [reload, setReload] = useState<number>(0);

  const reloadFn = () => {
    setData(null);
    setReload((prev) => prev + 1);
  };

  const tenantBrandingAction = async (action: ActionType, data: any) => {
    const { actionFn, fnMsg } = handleTenantBrandingActionFunction(action, t);
    setAppState((prev) => ({
      ...prev,
      isLoading: true,
    }));
    const actionStatus = await Promise.resolve(actionFn(data))
      .then((response) => {
        toast.current.replace({
          severity: "success",
          summary: "",
          detail: `${fnMsg}`,
          life: 3000,
        });
        return "SUCCESS";
      })
      .catch((error) => {
        toast.current.replace({
          severity: "error",
          summary: "",
          detail: error?.response?.data?.header?.errorMsg ?? t('ConsoleTranslations.generalErrorApiMessage'),
          life: 3000,
        });
        return "ERROR";
      });
    setAppState((prev) => ({
      ...prev,
      isLoading: false,
    }));
    return actionStatus;
  };

  const getBrandingInfo = async (tenantid: string) => {
    if (type === "DATA"){
      return await Promise.resolve(getTenantBranding(tenantid))
        .then(async (response) => {
          return await response?.data;
        })
        .catch((error) => {
          if (error?.response?.status !== 404) {
            toast.current.replace({
              severity: "error",
              summary: "",
              detail: error?.response?.header?.errorMsg ?? t('ConsoleTranslations.generalErrorApiMessage'),
              life: 3000,
            });
          }
        });
    }
  }

  return {
    getBrandingInfo,
    tenantBrandingAction,
    reloadFn,
  };
};